// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  firebase: {
    apiKey: "AIzaSyD6dAdg9gVyRHwSVBeVIEf6SpybhNa9R8o",
    authDomain: "se-ngo.firebaseapp.com",
    databaseURL: "https://se-ngo.firebaseio.com",
    projectId: "se-ngo",
    storageBucket: "se-ngo.appspot.com",
    messagingSenderId: "382020457337",
    appId: "1:382020457337:web:245ef4f842f5f8bf8dd5a8"

  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
